import admin from './admin'
import customer from './customer'

// exporty  Array of sections
export default [...admin, ...customer]
